var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18.2222 4H5.77778C4.5 4 4 4.5 4 5.77778V18.2222C4 19.5 4.5 20 5.77778 20H18.2222C19.5 20 20 19.5 20 18.2222V5.77778C20 4.5 19.5 4 18.2222 4Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0327 16.3388L5.42162 11.6832C5.34926 11.5978 5.31179 11.4883 5.3167 11.3764C5.32161 11.2646 5.36854 11.1588 5.44811 11.08C5.52768 11.0013 5.63403 10.9555 5.74591 10.9517C5.85779 10.948 5.96695 10.9866 6.05159 11.0599L10.0304 15.081L17.8893 7.31348C17.9747 7.24112 18.0843 7.20365 18.1961 7.20856C18.308 7.21347 18.4138 7.2604 18.4925 7.33997C18.5713 7.41954 18.6171 7.52589 18.6208 7.63777C18.6246 7.74965 18.5859 7.85881 18.5127 7.94345L10.0327 16.3388Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.5e90e007bfe5cc184a43a0a2ad829fd8.svg";
export { ForwardRef as ReactComponent };